export default __webpack_public_path__ + "static/media/historia.0eb096e6.png";